import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=cf79f1f4&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=cf79f1f4&scoped=true&lang=css&"
import style1 from "./Onboarding.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf79f1f4",
  null
  
)

export default component.exports